// extracted by mini-css-extract-plugin
export default {"container":"DismissibleSlide-module__container","hide":"DismissibleSlide-module__hide"};